import React from 'react'
import {_L, useLocaleState} from '../../context/LocaleContext'
import styled from 'styled-components'
import Icons from '../Icons'
import MediaQuery from 'react-responsive'

const UserMenu = ({user}) => {
  const localeState = useLocaleState()
  const {employee} = user
  const {nameFirst, emName} = employee
  
  const isGuestUser =
	    user.name === 'GUEST'

  let employeeName = nameFirst || emName
  let userMenuName = user.employee.id ? employeeName : user.name
  let welcomeText = _L({key: 'Welcome', localeState})
  let welcomeStr = `${welcomeText}, `

  const renderSmallUserMenu = () => {
    return (
      <Container>
        <IconContainer>
          <Icons icon="PROFILE" width={22} height={22} />
        </IconContainer>
        <UserMenuDetails>
          <MyAccount>
            <MyAccountArrow>
              <Icons icon="USER_MENU_ARROW" />
            </MyAccountArrow>
          </MyAccount>
        </UserMenuDetails>
      </Container>
    )
  }

  const renderLargeUserMenu = () => {
    return (
      <Container>
        <IconContainer>
          <Icons icon="PROFILE" width={22} height={22} />
        </IconContainer>
        {!isGuestUser && (
          <UserMenuDetails>
          	<UserWelcome>
          	  {welcomeStr}
              <UserWelcomeText>{userMenuName}</UserWelcomeText>
            </UserWelcome>
            <MyAccount>
              <MyAccountText>
                {_L({key: 'MY ACCOUNT', localeState})}
              </MyAccountText>
              <MyAccountArrow>
                <Icons icon="USER_MENU_ARROW" />
              </MyAccountArrow>
            </MyAccount>
          </UserMenuDetails>
        )}
      </Container>
    )
  }

  return (
    <MediaQuery query="(max-width: 420px)">
      {matches => (matches ? renderSmallUserMenu() : renderLargeUserMenu())}
    </MediaQuery>
  )
}

export default UserMenu

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  @media (max-width: 1023px) {
    padding-right: 6px;
  }
  @media (max-width: 420px) {
    padding-right: 0;
  }
`

const IconContainer = styled.div`
  padding-top: 6px;
`

const UserMenuDetails = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 10px;
  @media (max-width: 420px) {
    padding: 0;
  }
`

const UserWelcome = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #ffffff;
`

const UserWelcomeText = styled.span`
  font-style: italic;
`

const MyAccount = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
`

const MyAccountText = styled.div`
  white-space: nowrap;
`

const MyAccountArrow = styled.div`
  align-items: center;
  display: flex;
  padding-left: 5px;
`
